import { FC } from "react";

import { OTTPurchaseContainer } from "@features/ottPurchase/container/OTTPurchaseContainer";

export const OTTPurchasePage: FC = () => {
  return <OTTPurchaseContainer />;
};
